import Command from './command';
import BackspaceCommand from './backspace';
export default Command.extend({
  processZeroWidth() {
    return this._doInsertCharacter();
  },
  processSingleBlock() {
    let commandResult = this._doBackspace();
    this.snapshotState();
    return this._doInsertCharacter(commandResult.get('shouldRerender'));
  },
  processMultiBlock() {
    let commandResult = this._doBackspace();
    this.snapshotState();
    return this._doInsertCharacter(commandResult.get('shouldRerender'));
  },
  _doInsertCharacter(shouldRerender) {
    let result = this.applyActionToFirstSelectedBlock('insertCharacter');
    return this.processBlockMutationResult(result, shouldRerender);
  },
  _doBackspace() {
    return BackspaceCommand.create({
      blockList: this.get('blockList'),
      selection: this.get('selection'),
      config: this.get('config')
    }).run();
  }
});